// extracted by mini-css-extract-plugin
export default {"root":"ImageLazy_root__tfFl-","loaded":"ImageLazy_loaded__bIZdp"};